import React from "react";
import connect from "Shared/connect";
import Icon from "Shared/Icon";
import Slider from "SiteLayout/Sliding/Slider";
import * as styles from "SiteLayout/Sliding/base.scss";
import { toggleMainMenu } from "SiteLayout/MainMenu/action-creators";
import MyMenigoIcon from "../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import { translate } from "Shared/translate";
import classnames from "classnames";
import getMenuIcon from "../../../Category/Commerce/Components/action-creators";
import { pushState } from "Shared/history";
class ProductsSlider extends React.Component {
    constructor(props) {
        super(props);
        this.back = () => this.setState({
            animation: "back",
            current: this.state.prevs[this.state.prevs.length - 1],
            prevs: this.state.prevs.slice(0, this.state.prevs.length - 1),
        }, () => {
            document.getElementById("MobileMenu").scrollTo(0, 0);
        });
        this.forward = (current) => this.setState({
            animation: "forward",
            current,
            prevs: this.state.prevs.concat([this.state.current]),
        });
        this.state = {
            animation: "forward",
            prevs: [],
            current: {
                displayName: props.displayName,
                ticket: undefined,
                code: undefined,
                productCount: 0,
                url: "/",
                description: "",
                children: props.children,
            },
        };
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.state.prevs.length > 0 && (React.createElement("div", { className: styles.header },
                React.createElement("a", { onClick: () => this.back() },
                    React.createElement(MyMenigoIcon, { name: "arrow" }),
                    this.state.current.displayName),
                React.createElement("a", { className: styles.close, onClick: this.props.toggleMainMenu },
                    React.createElement(Icon, { name: "close" })))),
            React.createElement(Slider, { direction: this.state.animation },
                React.createElement("div", { className: this.state.animation == "forward"
                        ? styles.slideIn
                        : styles.slideOut, key: this.state.current.url },
                    this.state.prevs.length > 0 && (React.createElement("a", { onClick: () => pushState(this.state.current.url) },
                        React.createElement("div", { className: classnames(styles.primary, styles.menuLinks) },
                            React.createElement("span", null, translate("/MainMenu/CategoryShowAll", this.state.current.displayName)),
                            React.createElement(MyMenigoIcon, { name: "arrow" })))),
                    this.state.current.children
                        .filter((i) => !!i.displayName)
                        .map((item) => {
                        const isParent = item.children && item.children.length > 0;
                        return (React.createElement("a", { key: item.url, onClick: () => isParent ? this.forward(item) : pushState(item.url) },
                            React.createElement("div", { className: classnames(styles.primary, styles.menuLinks) },
                                React.createElement("span", null,
                                    !!getMenuIcon(item, this.props.categoryIcons) && (React.createElement(MyMenigoIcon, { name: getMenuIcon(item, this.props.categoryIcons) })),
                                    item.displayName),
                                React.createElement(MyMenigoIcon, { name: "arrow" }))));
                    })))));
    }
}
export default connect((state) => ({
    mainMenu: state.appShellData.mainMenu,
    categoryIcons: state.appShellData.categoryIcons,
}), (dispatch) => ({
    toggleMainMenu: () => dispatch(toggleMainMenu()),
}))(ProductsSlider);
